

































  import { Component, Prop } from 'vue-property-decorator'
  import { namespace } from 'vuex-class'
  import { Products } from '@one/types'
  import { Wishlist } from '@one/types/dist/orderpath/app'
  import { mixins } from 'nuxt-property-decorator'
  import { ProductItem, GTMListType } from '~/plugins/gtm/gtm'
  import AddToCartMixin from '~/mixins/AddToCartMixin'

  const products = namespace('products')
  const layout = namespace('layout')
  const wishlist = namespace('wishlist')
  const cart = namespace('cart')
  const stocks = namespace('stocks')

  @Component({
    components: {
      OneProductOverview: () => import('~/components/organisms/catalog/OneProductOverview.vue'),
      OneSwiperProduct: () => import('~/components/molecules/swipers/OneSwiperProduct.vue'),
    },
  })
  export default class OneTopProducts extends mixins<AddToCartMixin>(AddToCartMixin) {
    name: string = 'OneCmsTopProducts.vue'
    inputValue: number | null = 1

    @cart.Getter getCurrentCartId: any
    @stocks.Getter sumProductQuantityInWarehouses: any
    @stocks.Getter getDefaultWarehouseId: any
    @products.Getter getProduct: any
    @products.Getter getProductOrderUnit: any
    @products.Getter getProductPrice: any
    @products.Getter getProductImage: any
    @layout.Getter getCurrency: any
    @layout.Getter isGrossSelected: any
    @stocks.Action fetchStocksForProductsAndWarehouses: any
    @stocks.State((state) => state.warehouses.allIds) allWarehousesIds!: Array<string>
    @products.Action fetchProductsById: any
    @products.Action fetchPricesForProducts: any
    @wishlist.Getter getCurrentWishlistId: any
    @wishlist.Action addProductToWishlist: any
    @wishlist.Getter getWishlistProduct: any
    @wishlist.Getter getCurrentWishlist: any

    @Prop({
      required: true,
      type: Array,
    })
    readonly products!: Array<string>

    @Prop({
      required: true,
      type: String,
    })
    readonly title!: string

    @Prop({
      type: Boolean,
      default: false,
    })
    readonly hideUnavailableProducts?: Boolean

    filteredProductsIds: Array<string> = []

    GTMListType = GTMListType

    refetchProductPricesAndStocks() {
      try {
        if (this.$utils.hasPricesEnabled) {
          this.fetchPricesForProducts(this.filteredProductsIds)
        }
        this.fetchStocksForProductsAndWarehouses({
          skus: this.filteredProductsIds,
          warehouses: this.allWarehousesIds,
        })
      } catch (error) {
        this.$logger.error(error)
      }
    }

    async created() {
      if (process.client) {
        this.$auth.$on('auth:logout', this.refetchProductPricesAndStocks)
        const productIds = this.products.filter(x => x)
        try {
          const allProducts = await this.fetchProductsById(productIds)
          this.filteredProductsIds = allProducts.map(x => x.id)
        } catch (e) {
          this.$logger.warn('fetching products warn ', e)
        }
        if (this.$utils.isPurchaseEnabledOrAuthenticated) {
          try {
            if (this.$utils.hasPricesEnabled) {
              await this.fetchPricesForProducts(this.filteredProductsIds)
            }
            await this.fetchStocksForProductsAndWarehouses({
              skus: this.filteredProductsIds,
              warehouses: this.allWarehousesIds,
            })
          } catch (e) {
            this.$logger.warn('fetching price, stocks or warehouses warn ', e)
          }
        }
      }

      const products = this.products
        .map((id: string) => this.getProduct(id))
        .filter((idx) => idx)
        .map((p: Products.Product) => {
          const price = this.getProductPrice(p.id)
          return {
            item_id: p.id,
            item_name: p.name,
            item_brand: (p.brand && p.brand.name) || p.manufacturer.name,
            item_variant: p.attributes.map((a) => a.name).join(', '),
            item_list: this.title,
            category: this.$routes.getCategoryPath(p.canonicalCategory) || '',
            price: price ? price.price : 0,
            discount: price ? price.catalogPrice - price.price : 0,
            quantity: price ? price.quantity : 0,
          } as ProductItem
        })
      this.$gtm?.productImpression(products, GTMListType.CMS_TOP_PRODUCTS)
    }

    onAddToCart(event: any) {
      this.addToCart(event.productId, event.amountOfProducts, 'index')
    }

    onAddToWishlist(event: Wishlist.Requests.ChangeNumberOfProductInWishlistOption) {
      this.addProductToWishlist({
        wishlistId: this.getCurrentWishlistId,
        newProduct: {
          productId: event.productId,
          amountOfProducts: event.amountOfProducts,
        },
      })
        .then(() => {
          this.$notify({
            group: 'alert',
            type: 'success',
            text: this.$t('product_page.alert_added_to_wishlist') as string,
          })
          const addedProduct = this.getWishlistProduct(this.getCurrentWishlistId)(event.productId)
          let discount = addedProduct.prices?.catalogPriceNet - addedProduct.prices?.unitNet
          discount = discount > 0 ? discount : 0
          this.$gtm.addToWishlist(
            {
              item_id: addedProduct.id,
              item_name: addedProduct.name,
              item_list_name: this.getCurrentWishlist.name,
              item_brand: addedProduct.brand?.name || '',
              category: this.$routes.getCategoryPath(addedProduct.canonicalCategory) || '',
              price: addedProduct.prices?.unitNet || 0,
              discount: discount,
              quantity: event.amountOfProducts || 0,
            },
            addedProduct.prices.unitNet * event.amountOfProducts,
          )
        })
        .catch((err: any) => {
          this.$logger.warn(err)
          this.$notify({
            group: 'alert',
            type: 'error',
            text: this.$t('errors.add_to_wishlist_error') as string,
          })
        })
    }

    onProductClick(product: Products.Product) {
      this.$router.push(this.$routes.getProductPath(product), () => {
        const price = this.getProductPrice(product.id)
        this.$gtm.selectItem(
          {
            item_name: product.name,
            item_id: product.id,
            item_brand: (product.brand && product.brand.name) || product.manufacturer.name,
            category: this.$routes.getCategoryPath(product.canonicalCategory) || '',
            price: price ? price?.price : 0,
            discount: price ? price?.catalogPrice - price?.price : 0,
          } as ProductItem,
          GTMListType.HOME,
        )
      })
    }
  }
